
export const ADD_PROFILE_DETAILS='ADD_PROFILE_DETAILS'



export const profileSettings = (payload:any) => ({
  type:ADD_PROFILE_DETAILS,
  payload: payload,
});
